export interface SortAttribute {
  value: string;
  viewValue: string;
}

export enum Direction {
  DESC = 'DESC',
  ASC = 'ASC',
}
